// extracted by mini-css-extract-plugin
export default {"tr":"DocumentsTabListItemUploading_tr__pV-24","td_input":"DocumentsTabListItemUploading_td_input__2-b84"};